

































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'

@Component
export default class ComponentRemuneracaoMedicaNavBar extends Vue {
  show: boolean = true;
  enableRotas: any[] = [
    { url: '/contratos', icone: 'library_books', texto: 'Contratos' },
    { url: '#', icone: 'gavel', texto: 'Regras' },
    { url: '#', icone: 'assignment', texto: 'Cadastros' },
    { url: '#', icone: 'storage', texto: 'Fontes' },
    { url: '#', icone: 'logout', texto: 'Sair' },
  ]

  async logout() {
    await Auth.logout()
  }

  disableRoute(texto: string) {
    const bool: boolean = texto.toLowerCase() !== 'contratos'
    return bool
  }

  toggleMenu() {
    //
  }
}
